import { Outlet } from 'react-router';
import bodyBg from '@/image/bodyBg.png'
import Header from './header';

const Layout = () => {
  return (
    <main >
      <img src={bodyBg} className='w-full fixed top-0 left-0 -z-10' alt="" />
      <Header />
      <Outlet />
    </main>
  );
};

export default Layout;
